module.exports = __webpack_public_path__ + "static/img/move.8678174f.png";